export const SunIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <g fill="currentColor">
        <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
        <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
      </g>
    </svg>
  );
};
export const UserIcon = ({
  fill = "currentColor",
  size,
  height,
  width,
  ...props
}) => {
  return (
    <svg
      data-name="Iconly/Curved/Profile"
      height={size || height || 24}
      viewBox="0 0 24 24"
      width={size || width || 24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path
          d="M11.845 21.662C8.153 21.662 5 21.088 5 18.787s3.133-4.425 6.845-4.425c3.692 0 6.845 2.1 6.845 4.4s-3.134 2.9-6.845 2.9z"
          data-name="Stroke 1"
        />
        <path
          d="M11.837 11.174a4.372 4.372 0 10-.031 0z"
          data-name="Stroke 3"
        />
      </g>
    </svg>
  );
};
export const MoonIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <path
        d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RupeeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16 12a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4h-3.07a8 8 0 0 1 .818 2H30a2 2 0 1 1 0 4h-2.252a8.01 8.01 0 0 1-6.121 5.834l6.037 9.057a2 2 0 1 1-3.328 2.218l-8-12A2 2 0 0 1 18 22h2c1.48 0 2.773-.804 3.465-2H18a2 2 0 1 1 0-4h5.465A4 4 0 0 0 20 14h-2a2 2 0 0 1-2-2"
        clip-rule="evenodd"
        stroke-width="1"
        stroke="#000"
      />
    </svg>
  );
};
export const RupeesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16 12a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4h-3.07a8 8 0 0 1 .818 2H30a2 2 0 1 1 0 4h-2.252a8.01 8.01 0 0 1-6.121 5.834l6.037 9.057a2 2 0 1 1-3.328 2.218l-8-12A2 2 0 0 1 18 22h2c1.48 0 2.773-.804 3.465-2H18a2 2 0 1 1 0-4h5.465A4 4 0 0 0 20 14h-2a2 2 0 0 1-2-2"
        clip-rule="evenodd"
        stroke-width="1"
        stroke="#000"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#000"
        d="M3.548 20.938h16.9a.5.5 0 0 0 0-1h-16.9a.5.5 0 0 0 0 1M9.71 17.18a2.6 2.6 0 0 0 1.12-.65l9.54-9.54a1.75 1.75 0 0 0 0-2.47l-.94-.93a1.79 1.79 0 0 0-2.47 0l-9.54 9.53a2.5 2.5 0 0 0-.64 1.12L6.04 17a.74.74 0 0 0 .19.72a.77.77 0 0 0 .53.22Zm.41-1.36a1.47 1.47 0 0 1-.67.39l-.97.26l-1-1l.26-.97a1.5 1.5 0 0 1 .39-.67l.38-.37l1.99 1.99Zm1.09-1.08l-1.99-1.99l6.73-6.73l1.99 1.99Zm8.45-8.45L18.65 7.3l-1.99-1.99l1.01-1.02a.75.75 0 0 1 1.06 0l.93.94a.754.754 0 0 1 0 1.06"
        stroke-width="0.5"
        stroke="#000"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fff"
        d="M456 480H136a24 24 0 0 1-24-24V128a16 16 0 0 1 16-16h328a24 24 0 0 1 24 24v320a24 24 0 0 1-24 24"
        strokeWidth="13"
        stroke="#000"
      />
      <path
        fill="#fff"
        d="M112 80h288V56a24 24 0 0 0-24-24H60a28 28 0 0 0-28 28v316a24 24 0 0 0 24 24h24V112a32 32 0 0 1 32-32"
        strokeWidth="13"
        stroke="#000"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
 return(
  <svg xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 40 40"
  >
    <path
      fill="#fff"
      d="M21.467 38.585h-2.948a2.505 2.505 0 0 1-2.504-2.499v-3.237a13.6 13.6 0 0 1-2.582-1.108l-2.057 2.044c-.961.943-2.589.934-3.536-.011l-2.084-2.097a2.5 2.5 0 0 1 .013-3.534l2.175-2.16a14 14 0 0 1-.803-2.003H3.909a2.51 2.51 0 0 1-2.5-2.507v-2.949a2.504 2.504 0 0 1 2.5-2.502h3.237a13.5 13.5 0 0 1 1.108-2.577l-2.41-2.434a2.5 2.5 0 0 1-.725-1.775a2.48 2.48 0 0 1 .743-1.762l2.091-2.081c.958-.94 2.597-.93 3.537.012l2.524 2.547c.64-.32 1.313-.59 2.009-.803V3.915c0-1.379 1.122-2.5 2.5-2.5h2.952a2.503 2.503 0 0 1 2.499 2.5v3.238a13.4 13.4 0 0 1 2.098.851L28.62 5.48c.961-.944 2.593-.93 3.536.012l2.08 2.096c.467.467.725 1.096.725 1.77a2.48 2.48 0 0 1-.739 1.766l-2.425 2.41c.435.794.789 1.63 1.055 2.494h3.24a2.503 2.503 0 0 1 2.499 2.5v2.944a2.504 2.504 0 0 1-2.499 2.503h-3.24a13 13 0 0 1-.853 2.1l2.159 2.174c.466.461.724 1.091.724 1.77c0 .666-.263 1.292-.739 1.764l-2.091 2.082c-.961.943-2.603.925-3.535-.014l-2.041-2.057c-.797.438-1.63.793-2.487 1.058v3.239a2.537 2.537 0 0 1-2.522 2.494m-8.185-8.034l.317.187a12.6 12.6 0 0 0 3.02 1.296l.347.097v3.953c0 .854.697 1.549 1.553 1.549h2.948a1.58 1.58 0 0 0 1.571-1.548v-3.948l.347-.097a12.3 12.3 0 0 0 2.931-1.249l.317-.187l2.557 2.576c.577.582 1.596.592 2.193.007l2.089-2.081c.295-.292.458-.679.458-1.089c0-.423-.158-.812-.445-1.096l-2.657-2.677l.169-.31c.45-.828.799-1.691 1.039-2.563l.097-.349h3.959c.854 0 1.549-.696 1.549-1.552v-2.944c0-.854-.695-1.55-1.549-1.55h-3.958l-.097-.348a12.4 12.4 0 0 0-1.243-2.938l-.186-.318l2.943-2.925c.296-.294.459-.682.459-1.092c0-.42-.159-.81-.448-1.098l-2.08-2.096a1.583 1.583 0 0 0-2.196-.006L26.243 9.17l-.31-.167a12.4 12.4 0 0 0-2.563-1.039l-.348-.097V3.915c0-.854-.695-1.55-1.549-1.55h-2.952c-.854 0-1.549.695-1.549 1.55v3.951l-.348.097c-.87.241-1.703.575-2.478.991l-.313.168l-3.019-3.046c-.581-.58-1.602-.589-2.195-.006L6.53 8.149a1.53 1.53 0 0 0-.461 1.092a1.54 1.54 0 0 0 .45 1.101l2.923 2.953l-.187.315a12.6 12.6 0 0 0-1.296 3.016l-.097.347H3.909c-.854 0-1.549.696-1.549 1.551v2.949c0 .855.695 1.553 1.551 1.556H7.86l.097.348c.232.836.565 1.668.992 2.475l.165.311l-2.674 2.653a1.55 1.55 0 0 0-.009 2.189l2.083 2.096c.588.585 1.599.591 2.195.006z"
      strokeWidth="1"
      stroke="#000"
    />
    <path
      fill="#fff"
      d="M20 27.302c-4.027 0-7.302-3.276-7.302-7.302c0-4.028 3.276-7.304 7.302-7.304c4.027 0 7.304 3.277 7.304 7.304c-.001 4.027-3.277 7.302-7.304 7.302m0-13.655A6.36 6.36 0 0 0 13.648 20A6.36 6.36 0 0 0 20 26.352A6.36 6.36 0 0 0 26.353 20A6.36 6.36 0 0 0 20 13.647"
      strokeWidth="1"
      stroke="#000"
    />
  </svg>
 );
};
export const UserIcons = () =>{
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 4a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 16s8 0 8-2c0-2.4-3.9-5-8-5s-8 2.6-8 5c0 2 8 2 8 2"
        strokeWidth="0.5"
        stroke="#000"
      />
    </svg>
  );
}
export const WalletIcon = () =>{
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M19.435 4.065H4.565a2.5 2.5 0 0 0-2.5 2.5v10.87a2.5 2.5 0 0 0 2.5 2.5h14.87a2.5 2.5 0 0 0 2.5-2.5V6.565a2.5 2.5 0 0 0-2.5-2.5m1.5 9.93h-6.42a2 2 0 0 1 0-4h6.42Zm-6.42-5a3 3 0 0 0 0 6h6.42v2.44a1.5 1.5 0 0 1-1.5 1.5H4.565a1.5 1.5 0 0 1-1.5-1.5V6.565a1.5 1.5 0 0 1 1.5-1.5h14.87a1.5 1.5 0 0 1 1.5 1.5v2.43Z"
        strokeWidth="0.5"
        stroke="#000"
      />
      <circle
        cx="14.519"
        cy="11.996"
        r="1"
        fill="#000"
        strokeWidth="0.5"
        stroke="#000"
      />
    </svg>
  );
}
export const ExposureIcon = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path fill="currentcolor" d="m8.58 17.25l.92-3.89l-3-2.58l3.95-.37L12 6.8l1.55 3.65l3.95.33l-3 2.58l.92 3.89L12 15.19zM12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8" stroke-width="0.5" stroke="#000"/></svg>
  );
};
export const RefreshIcon =() =>{
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <g class="refresh-outline">
        <g
          fill-rule="evenodd"
          fill="#fff"
          class="Vector"
          clip-rule="evenodd"
          strokeWidth="0.5"
          stroke="#000"
        >
          <path d="M17.501 8.196c-1.873-3.246-6.008-4.358-9.234-2.494a6.7 6.7 0 0 0-2.804 3.137A1 1 0 1 1 3.63 8.04a8.7 8.7 0 0 1 3.637-4.07c4.188-2.42 9.544-.971 11.966 3.225a8.8 8.8 0 0 1 1.112 3.303l-1.984.25a6.8 6.8 0 0 0-.86-2.552" />
          <path d="M21.268 7.489c.43.2.616.71.416 1.138l-1.227 2.635a1.086 1.086 0 0 1-1.445.523l-2.636-1.236a.857.857 0 1 1 .728-1.551l2.064.969l.96-2.064a.857.857 0 0 1 1.14-.414M6.499 15.804c1.873 3.246 6.008 4.358 9.234 2.494a6.7 6.7 0 0 0 2.804-3.137a1 1 0 1 1 1.833.799a8.7 8.7 0 0 1-3.637 4.07c-4.188 2.42-9.545.971-11.966-3.225a8.8 8.8 0 0 1-1.112-3.303l1.984-.25c.11.873.39 1.74.86 2.552" />
          <path d="M2.732 16.511a.857.857 0 0 1-.416-1.138l1.227-2.635a1.086 1.086 0 0 1 1.445-.523l2.635 1.236a.857.857 0 1 1-.727 1.551l-2.064-.969l-.96 2.064a.857.857 0 0 1-1.14.414" />
        </g>
      </g>
    </svg>
  );
}
export const TickIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="2em"
      role="presentation"
      viewBox="0 0 24 24"
      width="3em"
      {...props}
    >
       <path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 14.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11" color="#000"/>
    </svg>
  );
};
export const CloseIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
       <path fill="#000" d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z" stroke-width="0.5" stroke="#000"/>
    </svg>
  );
};
export const DownArrowIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-3 h-3 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
  );
}
export const ResetIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 21 21"><g fill="none" fill-rule="evenodd" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"><path d="M14.5 3.5c2.414 1.377 4 4.022 4 7a8 8 0 1 1-8-8"/><path d="M14.5 7.5v-4h4"/></g></svg>
  );
}
export const TimeIcon = (props) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="#ffcc99" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H7v-1.5h4V7h1.5z" stroke-width="0.5" stroke="#000"/></svg>
  );
}
export const LoserIcon = (props) => {  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 256 256"><path fill="currentcolor" d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88a88.1 88.1 0 0 1-88 88M80 108a12 12 0 1 1 12 12a12 12 0 0 1-12-12m96 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12m-1.08 64a8 8 0 1 1-13.84 8c-7.47-12.91-19.21-20-33.08-20s-25.61 7.1-33.08 20a8 8 0 1 1-13.84-8c10.29-17.79 27.39-28 46.92-28s36.63 10.2 46.92 28" stroke-width="1.5" stroke="#000"/></svg>
  );
}
export const WinnerIcon = (props) => {    
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 32 32"><path fill="currentColor" d="M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4a4.5 4.5 0 0 0 4.25 4.493A8.01 8.01 0 0 0 15 21.938V24h-3.5A3.5 3.5 0 0 0 8 27.5v1A1.5 1.5 0 0 0 9.5 30h13a1.5 1.5 0 0 0 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.062a8.01 8.01 0 0 0 6.75-5.945A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3zm13 11.95V7h1.5a.5.5 0 0 1 .5.5v4a2.5 2.5 0 0 1-2 2.45M8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4a.5.5 0 0 1 .5-.5z" stroke-width="2.5"/></svg>
  );
}